/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Staatsexamen_Medizin_Pharmazie33Inputs */

const en__field_enum_icsrm_staatsexamen_medizin_pharmazie33 = /** @type {(inputs: _Field_Enum_Icsrm_Staatsexamen_Medizin_Pharmazie33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Medizin / Pharmazie`)
};

const de__field_enum_icsrm_staatsexamen_medizin_pharmazie33 = /** @type {(inputs: _Field_Enum_Icsrm_Staatsexamen_Medizin_Pharmazie33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Medizin / Pharmazie`)
};

/**
* | output |
* | --- |
* | "Staatsexamen Medizin / Pharmazie" |
*
* @param {_Field_Enum_Icsrm_Staatsexamen_Medizin_Pharmazie33Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_staatsexamen_medizin_pharmazie33 = /** @type {((inputs?: _Field_Enum_Icsrm_Staatsexamen_Medizin_Pharmazie33Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Staatsexamen_Medizin_Pharmazie33Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_staatsexamen_medizin_pharmazie33(inputs)
	return de__field_enum_icsrm_staatsexamen_medizin_pharmazie33(inputs)
});
export { _field_enum_icsrm_staatsexamen_medizin_pharmazie33 as "_field_enum_ICSRM_STAATSEXAMEN_MEDIZIN_PHARMAZIE" }